import React from "react";

const Header = () => {
  return <h1>Typing Speed App</h1>;
};

export default Header;
